jQuery(document).ready(function ($) {
    var ajaxurl = 'https://api.icepick.co/bamboo_stickers/index.php';
  
    // Debug AJAX requests - only critical errors
    $(document).ajaxError(function(event, jqxhr, settings, error) {
        console.error('AJAX Error:', {
            url: settings.url,
            status: jqxhr.status,
            error: error
        });
    });
  
    $.fn.checkFileStatus = function (file_id) {
      return new Promise((resolve, reject) => {
        function checkStatus() {
          $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
              action: 'gw_checkFileStatus',
              file_id: file_id,
            },
            dataType: 'json',
            success: (data) => {
              // Verify if data is a string (possibly unparsed JSON)
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  console.error('Error parsing JSON:', e);
                }
              }
              
              if (data.status === 'continue_searching_status') {
                setTimeout(checkStatus, 1000);
              } else if (data.status === 'success') {
                resolve(data.file_url);
              } else if (data.status === 'error') {
                reject(data.message || 'Unknown error from server');
              } else {
                reject('Unknown status: ' + data.status);
              }
            },
            error: (xhr, status, error) => {
              // Try to parse the responseText as JSON
              let errorMessage = error;
              try {
                if (xhr.responseText) {
                  const errorResponse = JSON.parse(xhr.responseText);
                  if (errorResponse.message) {
                    errorMessage = errorResponse.message;
                  }
                }
              } catch (e) {}
              
              reject(errorMessage);
            }
          });
        }
    
        // Start the verification process
        checkStatus();
      });
    };
  
    //UPLOADER
    $.fn.uploadImageField = function () {
      $('[data-image-uploader]').not('.uploader_loaded').each(function (idx, field) {
        $(field).addClass('uploader_loaded');
    
        const input_name = $(field).attr('name');
        const save_input_name = input_name.replace('_uploader', '');
    
        const item_html = `
          <div class="file_item">
            \${image}
            <span class="remove_item" data-action="fileuploader-remove"><i class="remove_item_icon"></i></span>
            <div class="progressbar3" style="display: none"></div>
          </div>
        `;
    
        $(field).fileuploader({
          theme: 'upload_box',
          addMore: true,
          enableApi: true,
          dragDrop: {
            container: '.file_uploader_box',
          },
          onSelect: function(item) {
            // Check only image files
            if (item.file && item.file.type.match('image.*')) {
              // Use Promise to handle async validation
              return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  var image = new Image();
                  image.onload = function() {
                    // We no longer need to validate dimensions as the server will handle resizing
                    // Just resolve the promise to allow the file to be added
                    resolve();
                  };
                  image.onerror = function() {
                    console.error('Error loading image for validation.');
                    // Reject if image cannot be loaded
                    reject(new Error('Could not load the image for validation.')); 
                  };
                  image.src = e.target.result;
                };
                reader.onerror = function() {
                  console.error('Error reading file for validation.');
                  // Reject if file cannot be read
                  reject(new Error('Could not read the file for validation.')); 
                };
                reader.readAsDataURL(item.file);
              }).then(function() {
                // Validation passed, allow the file by returning true
                return true;
              }).catch(function(error) {
                // Validation failed, prevent the file by returning false
                // The alert is already shown inside the promise
                return false;
              });
            } else {
              // Not an image file, allow it by returning true
              return true;
            }
          },
          changeInput:
            '<div class="file_uploader_box position-relative w-100"><div class="fileuploader-droparea" data-action="fileuploader-input"></div></div>',
          thumbnails: {
            box: '<div class="thumbnails_area">' + '<div class="file_items"></div>' + '</div>',
            item: item_html,
            item2: null,
            itemPrepend: true,
            startImageRenderer: true,
            canvasImage: false,
            _selectors: {
              list: '.file_items',
            },
          },
          onListInput: function (list, fileList, listInputEl, listEl, parentEl, newInputEl, inputEl) {
            if (fileList.length > 0) $(parentEl).addClass('with_items');
            return list;
          },
          afterRender: function (listEl, parentEl, newInputEl, inputEl) {
            var api = $.fileuploader.getInstance(inputEl);
    
            parentEl.on('click', '[data-action]', function () {
              var $this = $(this),
                action = $this.attr('data-action'),
                item = api.getFiles().length ? api.getFiles()[api.getFiles().length - 1] : null;
    
              switch (action) {
                case 'fileuploader-input':
                  api.open();
                  break;
                case 'fileuploader-edit':
                  if (item && item.popup) {
                    if (!$this.is('.fileuploader-action-popup')) item.popup.open();
                    item.editor.cropper();
                  }
                  break;
                case 'fileuploader-retry':
                  if (item && item.upload.retry) {
                    item.upload.retry();
                  }
                  break;
                case 'fileuploader-remove':
                  if (item) {
                    item.remove();
                    $('#add_to_cart_button').prop('disabled', true);
                  }
                  break;
              }
            });
          },
          onRemove: function (item, listEl, parentEl, newInputEl, inputEl) {
            console.log('Removing file:', item);
            
            // Clear the input field value
            $(`#${save_input_name}`).val('');
            
            // Only try to delete from server if we have an attachment ID
            if (item.data && item.data.attachment_id) {
              $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                  action: 'gw_deleteFile',
                  file: item.data.attachment_id,
                },
                success: (response) => {
                  console.log('File deleted from server');
                },
                error: (xhr, status, error) => {
                  console.error('Error deleting file from server');
                }
              });
            }
          },
          onEmpty: function (listEl, parentEl, newInputEl, inputEl) {
            $(parentEl).removeClass('with_items');
          },
          upload: {
            url: ajaxurl,
            type: 'POST',
            enctype: 'multipart/form-data',
            data: {
              action: 'gw_uploadFile',
              input_name: input_name,
            },
            start: true,
            synchron: true,
            beforeSend: () => {
              $('.upload_input_wrapper').addClass('loading');
            },
            onSuccess: function (result, item) {
              console.log('Raw upload response:', result);
              
              // Verify if result is a string (possibly unparsed JSON)
              if (typeof result === 'string') {
                try {
                  result = JSON.parse(result);
                  console.log('Parsed JSON result:', result);
                } catch (e) {
                  console.error('Error parsing JSON result:', e);
                  console.error('Raw result that failed to parse:', result);
                  $('.upload_input_wrapper').removeClass('loading');
                  item.html.find('.progress-bar').hide();
                  item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: Invalid server response</div>');
                  return false;
                }
              }
              
              // Clear any previous error messages
              item.html.find('.error-message').remove();
              
              if (result.status === 'pending') {
                console.log('File upload pending, checking status for file_id:', result.file_id);
                // Show waiting message
                item.html.find('.progress-bar').html('<span>Processing image...</span>');
                
                // Use checkFileStatus as a promise
                $.fn.checkFileStatus(result.file_id)
                  .then(file_url => {
                    console.log('File ready, resolving with URL:', file_url);
                    $(`#${save_input_name}`).val(file_url);
                    
                    $('.upload_input_wrapper').removeClass('loading');
                    $('#add_to_cart_button').prop('disabled', false);
                    
                    // Hide progress bar after completion
                    setTimeout(() => {
                      item.html.find('.progress-bar').fadeOut(400);
                    }, 400);
                  })
                  .catch(error => {
                    console.error('Error checking file status:', error);
                    $('.upload_input_wrapper').removeClass('loading');
                    
                    // Show error message in the interface
                    item.html.find('.progress-bar').hide();
                    item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: ' + error + '</div>');
                    
                    // Enable retry button
                    if (item.html.find('.fileuploader-action-retry').length === 0) {
                      item.html.find('.column-actions').prepend(
                        '<button type="button" class="fileuploader-action fileuploader-action-retry" title="Retry"><i class="fileuploader-icon-retry"></i></button>'
                      );
                    }
                  });
              } else if (result.status === 'success') {
                console.log('Upload Success', result.file_url);
                // If the file was uploaded successfully without verification
                $(`#${save_input_name}`).val(result.file_url || '');
                
                $('.upload_input_wrapper').removeClass('loading');
                $('#add_to_cart_button').prop('disabled', false);
                
                // Hide progress bar after completion
                setTimeout(() => {
                  item.html.find('.progress-bar').fadeOut(400);
                }, 400);
              } else if (result.status === 'error') {
                console.error('Upload error:', result);
                $('.upload_input_wrapper').removeClass('loading');
                
                // Show error message in the interface
                item.html.find('.progress-bar').hide();
                let errorMessage = 'Unknown error uploading file';
                
                // Handle specific errors
                if (result.warnings && result.warnings.length > 0) {
                  const warning = result.warnings[0];
                  if (warning.includes('upload_max_filesize')) {
                    errorMessage = 'The file is too large. Please reduce the image size to less than 200MB.';
                  } else {
                    errorMessage = warning;
                  }
                } else if (result.message) {
                  errorMessage = result.message;
                }
                
                item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: ' + errorMessage + '</div>');
                
                // Enable retry button
                if (item.html.find('.fileuploader-action-retry').length === 0) {
                  item.html.find('.column-actions').prepend(
                    '<button type="button" class="fileuploader-action fileuploader-action-retry" title="Retry"><i class="fileuploader-icon-retry"></i></button>'
                  );
                }
                
                return false;
              } else {
                console.error('Unknown status:', result);
                $('.upload_input_wrapper').removeClass('loading');
                
                // Show error message in the interface
                item.html.find('.progress-bar').hide();
                item.html.append('<div class="error-message" style="color: red; margin-top: 5px;">Error: Unknown server status</div>');
                
                return false;
              }
            },
            onError: function (item) {
              var progressBar = item.html.find('.progress-bar');
    
              if (progressBar.length) {
                progressBar.find('span').html(0 + '%');
                progressBar.find('.fileuploader-progressbar .bar').width(0 + '%');
                item.html.find('.progress-bar').fadeOut(400);
              }
    
              item.upload.status != 'cancelled' && item.html.find('.fileuploader-action-retry').length == 0
                ? item.html
                    .find('.column-actions')
                    .prepend(
                      '<button type="button" class="fileuploader-action fileuploader-action-retry" title="Retry"><i class="fileuploader-icon-retry"></i></button>'
                    )
                : null;
            },
            onProgress: function (data, item) {
              var progressBar = item.html.find('.progress-bar');
    
              if (progressBar.length > 0) {
                progressBar.show();
                progressBar.find('span').html(data.percentage + '%');
                progressBar.find('.fileuploader-progressbar .bar').width(data.percentage + '%');
              }
            },
            onComplete: null,
          },
        });
      });
    };
    
    $.fn.uploadImageField();
  });
  